import React, { useState, useEffect } from 'react';

const EnhancedFractionsGame = () => {
  // משתני State
  const [gameMode, setGameMode] = useState('menu'); // 'menu', 'name', 'visualGame', 'mathGame', 'calcGame', 'wordProblems'
  const [playerName, setPlayerName] = useState('');
  const [nameEntered, setNameEntered] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showExplanation, setShowExplanation] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [gameCompleted, setGameCompleted] = useState(false);
  const [showReward, setShowReward] = useState(false);
  const [rewardMessage, setRewardMessage] = useState('');
  const [streak, setStreak] = useState(0);
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [incorrectAnswers, setIncorrectAnswers] = useState([]);
  const [summaryVisible, setSummaryVisible] = useState(true);
  
  // שאלות זיהוי שברים - מותאם לדפי העבודה
  const visualQuestions = [
    {
      id: 'v1',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "circle",
      shadedParts: 3,
      totalParts: 8,
      options: ["3/8", "5/8", "3/5", "8/3"],
      correctAnswer: "3/8",
      explanation: "העיגול מחולק ל-8 חלקים שווים, ו-3 חלקים מהם צבועים. לכן, החלק הצבוע הוא 3/8."
    },
    {
      id: 'v2',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "rectangle",
      shadedParts: 2,
      totalParts: 6,
      options: ["1/3", "2/6", "1/6", "4/6"],
      correctAnswer: "2/6",
      explanation: "המלבן מחולק ל-6 חלקים שווים, ו-2 חלקים מהם צבועים. לכן, החלק הצבוע הוא 2/6 (ששווה ל-1/3 לאחר צמצום)."
    },
    {
      id: 'v3',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "circle",
      shadedParts: 1,
      totalParts: 4,
      options: ["1/4", "1/3", "2/8", "3/4"],
      correctAnswer: "1/4",
      explanation: "העיגול מחולק ל-4 חלקים שווים, וחלק אחד מהם צבוע. לכן, החלק הצבוע הוא 1/4."
    },
    {
      id: 'v4',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "rectangle",
      shadedParts: 3,
      totalParts: 4,
      options: ["3/4", "1/4", "2/3", "4/3"],
      correctAnswer: "3/4",
      explanation: "המלבן מחולק ל-4 חלקים שווים, ו-3 חלקים מהם צבועים. לכן, החלק הצבוע הוא 3/4."
    },
    {
      id: 'v5',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "circle",
      shadedParts: 4,
      totalParts: 6,
      options: ["4/6", "2/3", "3/4", "2/6"],
      correctAnswer: "4/6",
      explanation: "העיגול מחולק ל-6 חלקים שווים, ו-4 חלקים מהם צבועים. לכן, החלק הצבוע הוא 4/6 (ששווה ל-2/3 לאחר צמצום)."
    },
    {
      id: 'v6',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "rectangle",
      shadedParts: 5,
      totalParts: 10,
      options: ["1/2", "5/10", "6/10", "5/5"],
      correctAnswer: "5/10",
      explanation: "המלבן מחולק ל-10 חלקים שווים, ו-5 חלקים מהם צבועים. לכן, החלק הצבוע הוא 5/10 (ששווה ל-1/2 לאחר צמצום)."
    },
    {
      id: 'v7',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "circle",
      shadedParts: 2,
      totalParts: 3,
      options: ["2/3", "1/3", "3/2", "1/2"],
      correctAnswer: "2/3",
      explanation: "העיגול מחולק ל-3 חלקים שווים, ו-2 חלקים מהם צבועים. לכן, החלק הצבוע הוא 2/3."
    },
    {
      id: 'v8',
      question: "איזה שבר מייצג את החלק הצבוע?",
      image: true,
      imageType: "rectangle",
      shadedParts: 1,
      totalParts: 2,
      options: ["1/2", "2/1", "1/4", "3/4"],
      correctAnswer: "1/2",
      explanation: "המלבן מחולק ל-2 חלקים שווים, וחלק אחד מהם צבוע. לכן, החלק הצבוע הוא 1/2."
    }
  ];
  
  // שאלות חיבור וחיסור שברים - מותאם לדפי העבודה
  const mathQuestions = [
    {
      id: 'm1',
      question: "חשב: 1/4 + 1/2 = ",
      options: ["3/4", "2/6", "1/2", "3/6"],
      correctAnswer: "3/4",
      explanation: "נמצא מכנה משותף: 1/4 = 1/4, 1/2 = 2/4. עכשיו נחבר: 1/4 + 2/4 = 3/4."
    },
    {
      id: 'm2',
      question: "חשב: 2/3 - 1/6 = ",
      options: ["1/2", "3/6", "1/3", "3/9"],
      correctAnswer: "1/2",
      explanation: "נמצא מכנה משותף: 2/3 = 4/6, 1/6 = 1/6. עכשיו נחסר: 4/6 - 1/6 = 3/6 = 1/2."
    },
    {
      id: 'm3',
      question: "חשב: 3/5 + 1/10 = ",
      options: ["7/10", "4/15", "4/5", "2/5"],
      correctAnswer: "7/10",
      explanation: "נמצא מכנה משותף: 3/5 = 6/10, 1/10 = 1/10. עכשיו נחבר: 6/10 + 1/10 = 7/10."
    },
    {
      id: 'm4',
      question: "חשב: 4/6 - 1/3 = ",
      options: ["1/6", "3/6", "2/3", "1/3"],
      correctAnswer: "1/6",
      explanation: "נמצא מכנה משותף: 4/6 = 4/6, 1/3 = 2/6. עכשיו נחסר: 4/6 - 2/6 = 2/6 = 1/3."
    },
    {
      id: 'm5',
      question: "חשב: 2 1/3 + 1 1/2 = ",
      options: ["3 5/6", "3 3/6", "4", "3 1/2"],
      correctAnswer: "3 5/6",
      explanation: "נמצא מכנה משותף: 1/3 = 2/6, 1/2 = 3/6. עכשיו נחבר את השברים: 2/6 + 3/6 = 5/6. נחבר את המספרים השלמים: 2 + 1 = 3. הסכום הוא 3 5/6."
    },
    {
      id: 'm6',
      question: "חשב: 5/8 + 1/4 = ",
      options: ["7/8", "6/12", "3/4", "6/8"],
      correctAnswer: "7/8",
      explanation: "נמצא מכנה משותף: 5/8 = 5/8, 1/4 = 2/8. עכשיו נחבר: 5/8 + 2/8 = 7/8."
    },
    {
      id: 'm7',
      question: "חשב: 7/12 - 1/6 = ",
      options: ["5/12", "1/2", "1/3", "1/4"],
      correctAnswer: "5/12",
      explanation: "נמצא מכנה משותף: 7/12 = 7/12, 1/6 = 2/12. עכשיו נחסר: 7/12 - 2/12 = 5/12."
    },
    {
      id: 'm8',
      question: "חשב: 3/4 + 1/8 = ",
      options: ["7/8", "4/12", "5/8", "1"],
      correctAnswer: "7/8",
      explanation: "נמצא מכנה משותף: 3/4 = 6/8, 1/8 = 1/8. עכשיו נחבר: 6/8 + 1/8 = 7/8."
    }
  ];
  
  // שאלות כפל וחילוק במספרים דו-ספרתיים
  const calcQuestions = [
    {
      id: 'mul1',
      question: "חשב: 24 × 35 = ",
      options: ["840", "860", "740", "940"],
      correctAnswer: "840",
      explanation: "כדי לכפול מספרים דו-ספרתיים, אפשר לפרק: 24 × 35 = (20 + 4) × (30 + 5) = 20×30 + 20×5 + 4×30 + 4×5 = 600 + 100 + 120 + 20 = 840."
    },
    {
      id: 'mul2',
      question: "חשב: 18 × 12 = ",
      options: ["216", "186", "196", "226"],
      correctAnswer: "216",
      explanation: "כפל מספרים דו-ספרתיים: 18 × 12 = 10×12 + 8×12 = 120 + 96 = 216."
    },
    {
      id: 'mul3',
      question: "חשב: 42 × 15 = ",
      options: ["630", "530", "730", "570"],
      correctAnswer: "630",
      explanation: "כפל מספרים דו-ספרתיים: 42 × 15 = 40×15 + 2×15 = 600 + 30 = 630."
    },
    {
      id: 'div1',
      question: "חשב: 325 ÷ 5 = ",
      options: ["65", "55", "75", "60"],
      correctAnswer: "65",
      explanation: "כדי לחלק 325 ב-5: 325 ÷ 5 = 300 ÷ 5 + 25 ÷ 5 = 60 + 5 = 65."
    },
    {
      id: 'div2',
      question: "חשב: 248 ÷ 8 = ",
      options: ["31", "32", "29", "34"],
      correctAnswer: "31",
      explanation: "כדי לחלק 248 ב-8: 240 ÷ 8 = 30, ונשאר 8 ÷ 8 = 1, לכן 248 ÷ 8 = 31."
    },
    {
      id: 'div3',
      question: "חשב: 96 ÷ 12 = ",
      options: ["8", "10", "7", "9"],
      correctAnswer: "8",
      explanation: "כדי לחלק 96 ב-12: 96 ÷ 12 = 8, כי 8 × 12 = 96."
    }
  ];
  
  // שאלות מילוליות עם חלק יחסי ושברים
  const wordProblems = [
    {
     id: 'w1',
      question: "יוסי אכל 1/3 מהעוגה, ודני אכל 1/4 מהעוגה. איזה חלק מהעוגה נשאר?",
      options: ["5/12", "7/12", "1/2", "1/4"],
      correctAnswer: "5/12",
      explanation: "נמצא מכנה משותף: 1/3 = 4/12, 1/4 = 3/12. עכשיו נחבר את החלקים שנאכלו: 4/12 + 3/12 = 7/12. החלק שנשאר הוא 1 - 7/12 = 5/12."
    },
    {
      id: 'w2',
      question: "בכיתה 24 תלמידים. 1/3 מהם בנים. כמה בנות יש בכיתה?",
      options: ["16", "8", "12", "20"],
      correctAnswer: "16",
      explanation: "מספר הבנים בכיתה: 1/3 × 24 = 8 בנים. מספר הבנות: 24 - 8 = 16 בנות."
    },
    {
      id: 'w3',
      question: "מיכל קנתה בקבוק שתייה של 2 ליטר. היא שתתה 3/4 מהבקבוק. כמה ליטרים נשארו בבקבוק?",
      options: ["0.5 ליטר", "1 ליטר", "1.5 ליטר", "0.25 ליטר"],
      correctAnswer: "0.5 ליטר",
      explanation: "החלק שנשאר בבקבוק: 1 - 3/4 = 1/4. כמות הליטרים שנשארה: 1/4 × 2 = 0.5 ליטר."
    },
    {
      id: 'w4',
      question: "דני קיבל מהמורה 20 מדבקות. הוא הדביק 1/4 מהמדבקות במחברת חשבון ו-2/5 מהמדבקות במחברת אנגלית. כמה מדבקות נשארו לו?",
      options: ["7", "8", "5", "13"],
      correctAnswer: "7",
      explanation: "מספר המדבקות שהודבקו במחברת חשבון: 1/4 × 20 = 5 מדבקות. מספר המדבקות שהודבקו במחברת אנגלית: 2/5 × 20 = 8 מדבקות. סה\"כ הודבקו: 5 + 8 = 13 מדבקות. נשארו: 20 - 13 = 7 מדבקות."
    },
    {
      id: 'w5',
      question: "בגינה יש פרחים אדומים, צהובים וכחולים. 1/3 מהפרחים הם אדומים, 1/4 מהפרחים הם צהובים, והשאר כחולים. אם יש 60 פרחים בגינה, כמה פרחים כחולים יש?",
      options: ["25", "20", "15", "30"],
      correctAnswer: "25",
      explanation: "מספר הפרחים האדומים: 1/3 × 60 = 20 פרחים. מספר הפרחים הצהובים: 1/4 × 60 = 15 פרחים. מספר הפרחים הכחולים: 60 - 20 - 15 = 25 פרחים."
    }
  ];
  
  // ערבוב שאלות ואפשרויות
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
  
  // התחלת משחק
  const startGame = (mode) => {
    setGameMode(mode);
    setCurrentQuestion(0);
    setScore(0);
    setStreak(0);
    setShowExplanation(false);
    setSelectedAnswer(null);
    setIsCorrect(null);
    setGameCompleted(false);
    setIncorrectAnswers([]);
    
    // בחירת שאלות לפי מצב המשחק
    let questions;
    if (mode === 'visualGame') {
      questions = visualQuestions;
    } else if (mode === 'mathGame') {
      questions = mathQuestions;
    } else if (mode === 'calcGame') {
      questions = calcQuestions;
    } else if (mode === 'wordProblems') {
      questions = wordProblems;
    }
    
    const shuffled = shuffleArray(questions);
    setShuffledQuestions(shuffled);
    
    // ערבוב אפשרויות התשובה לשאלה הראשונה
    if (shuffled.length > 0) {
      setShuffledOptions(shuffleArray(shuffled[0].options));
    }
  };
  
  // עדכון אפשרויות התשובה בכל פעם שמשתנה השאלה הנוכחית
  useEffect(() => {
    if (shuffledQuestions.length > 0 && currentQuestion < shuffledQuestions.length) {
      setShuffledOptions(shuffleArray(shuffledQuestions[currentQuestion].options));
    }
  }, [currentQuestion, shuffledQuestions]);
  
  // בדיקת תשובה
  const handleAnswer = (answer) => {
    if (!shuffledQuestions[currentQuestion] || showExplanation) return;
    
    setSelectedAnswer(answer);
    const current = shuffledQuestions[currentQuestion];
    const correct = answer === current.correctAnswer;
    setIsCorrect(correct);
    
    if (correct) {
      setScore(score + 10);
      setStreak(streak + 1);
      
      // הצגת הודעת עידוד אם יש רצף של תשובות נכונות
      if ((streak + 1) % 3 === 0) {
        setRewardMessage(`כל הכבוד ${playerName}! ענית נכון על ${streak + 1} שאלות ברצף!`);
        setShowReward(true);
        setTimeout(() => setShowReward(false), 2000);
      }
    } else {
      setStreak(0);
      // שמירת השאלות שהתשובה עליהן שגויה לדוח המסכם
      setIncorrectAnswers(prev => [...prev, {
        question: current.question,
        yourAnswer: answer,
        correctAnswer: current.correctAnswer,
        explanation: current.explanation
      }]);
    }
    
    setShowExplanation(true);
  };
  
  // מעבר לשאלה הבאה
  const nextQuestion = () => {
    setShowExplanation(false);
    setSelectedAnswer(null);
    setIsCorrect(null);
    
    if (currentQuestion < shuffledQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setGameCompleted(true);
    }
  };
  
  // חזרה לתפריט
  const backToMenu = () => {
    setGameMode('menu');
    setGameCompleted(false);
  };
  
  // התחלה מחדש של אותו סוג משחק
  const restartGame = () => {
    startGame(gameMode);
  };
  
  // רינדור תמונה
  const renderImage = () => {
    if (!shuffledQuestions[currentQuestion] || !shuffledQuestions[currentQuestion].image) return null;
    
    if (shuffledQuestions[currentQuestion].imageType === "circle") {
      return (
        <div className="flex justify-center mb-6">
          <svg width="200" height="200" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" fill="none" stroke="black" strokeWidth="1" />
            
            {Array.from({ length: shuffledQuestions[currentQuestion].totalParts }).map((_, index) => {
              const angle = (360 / shuffledQuestions[currentQuestion].totalParts) * index;
              return (
                <line 
                  key={index}
                  x1="50"
                  y1="50"
                  x2={50 + 45 * Math.cos(angle * Math.PI / 180)}
                  y2={50 + 45 * Math.sin(angle * Math.PI / 180)}
                  stroke="black"
                  strokeWidth="1"
                />
              );
            })}
            
            {Array.from({ length: shuffledQuestions[currentQuestion].shadedParts }).map((_, index) => {
              const startAngle = (360 / shuffledQuestions[currentQuestion].totalParts) * index;
              const endAngle = (360 / shuffledQuestions[currentQuestion].totalParts) * (index + 1);
              
              const x1 = 50 + 45 * Math.cos(startAngle * Math.PI / 180);
              const y1 = 50 + 45 * Math.sin(startAngle * Math.PI / 180);
              const x2 = 50 + 45 * Math.cos(endAngle * Math.PI / 180);
              const y2 = 50 + 45 * Math.sin(endAngle * Math.PI / 180);
              
              return (
                <path
                  key={index}
                  d={`M 50 50 L ${x1} ${y1} A 45 45 0 0 1 ${x2} ${y2} Z`}
                  fill="#09f"
                  stroke="black"
                  strokeWidth="0.5"
                />
              );
            })}
          </svg>
        </div>
      );
    }
    
    if (shuffledQuestions[currentQuestion].imageType === "rectangle") {
      const width = 200;
      const height = 120;
      const partWidth = width / shuffledQuestions[currentQuestion].totalParts;
      
      return (
        <div className="flex justify-center mb-6">
          <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            <rect width={width} height={height} fill="none" stroke="black" strokeWidth="1" />
            
            {Array.from({ length: shuffledQuestions[currentQuestion].totalParts }).map((_, index) => {
              return (
                <rect
                  key={index}
                  x={index * partWidth}
                  y="0"
                  width={partWidth}
                  height={height}
                  fill={index < shuffledQuestions[currentQuestion].shadedParts ? "#09f" : "none"}
                  stroke="black"
                  strokeWidth="1"
                />
              );
            })}
          </svg>
        </div>
      );
    }
    
    return null;
  };
  
  // פונקציה להצגת שבר בצורה יפה
  const renderFraction = (fractionStr) => {
    if (!fractionStr || typeof fractionStr !== 'string' || !fractionStr.includes('/')) return fractionStr;
    
    const parts = fractionStr.split('/');
    
    // בדיקה אם זה מספר מעורב
    if (parts[0].includes(' ')) {
      const mixedParts = parts[0].split(' ');
      return (
        <span className="inline-flex flex-row items-center">
          <span className="mr-1">{mixedParts[0]}</span>
          <span className="inline-flex flex-col items-center">
            <span className="text-xs border-b border-black">{mixedParts[1]}</span>
            <span className="text-xs">{parts[1]}</span>
          </span>
        </span>
      );
    }
    
    return (
      <span className="inline-flex flex-col items-center mx-1">
        <span className="text-xs border-b border-black">{parts[0]}</span>
        <span className="text-xs">{parts[1]}</span>
      </span>
    );
  };
  
  // עיבוד טקסט עם שברים
  const processText = (text) => {
    if (!text) return null;
    
    const parts = text.split(/(\d+\/\d+|\d+\s\d+\/\d+)/g);
    
    return (
      <>
        {parts.map((part, index) => {
          if (/\d+\/\d+/.test(part) || /\d+\s\d+\/\d+/.test(part)) {
            return <span key={index}>{renderFraction(part)}</span>;
          }
          return <span key={index}>{part}</span>;
        })}
      </>
    );
  };
  
  // טיפול בהזנת שם
  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (playerName.trim().length > 0) {
      setNameEntered(true);
    }
  };

  // הצגת הדוח המסכם או הסתרתו
  const toggleSummary = () => {
    setSummaryVisible(!summaryVisible);
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-blue-50 rounded-lg shadow-lg text-right font-sans" dir="rtl">
      <h1 className="text-2xl font-bold text-center mb-6 text-blue-800">משחק תרגול: שברים וחשבון</h1>
      
      {!nameEntered ? (
        <div className="text-center">
          <h2 className="text-xl font-bold mb-6">ברוך הבא למשחק השברים!</h2>
          <form onSubmit={handleNameSubmit} className="mb-6">
            <div className="mb-4">
              <label htmlFor="playerName" className="block mb-2 text-lg">מה השם שלך?</label>
              <input 
                type="text" 
                id="playerName" 
                value={playerName} 
                onChange={(e) => setPlayerName(e.target.value)}
                className="p-2 border rounded-md w-64 text-right"
                placeholder="הכנס את שמך כאן"
              />
            </div>
            <button 
           type="submit" 
              className="px-6 py-2 bg-blue-600 text-white rounded-md font-bold hover:bg-blue-700 transition"
            >
              התחל לשחק
            </button>
          </form>
        </div>
      ) : gameMode === 'menu' ? (
        <div className="text-center">
          <h2 className="text-xl font-bold mb-2">שלום {playerName}!</h2>
          <p className="mb-6">בחר את סוג המשחק שתרצה לשחק</p>
          
          <div className="grid grid-cols-1 gap-4 max-w-md mx-auto">
            <button 
              onClick={() => startGame('visualGame')}
              className="p-4 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition"
            >
              זיהוי שברים בתמונות
            </button>
            
            <button 
              onClick={() => startGame('mathGame')}
              className="p-4 bg-green-600 text-white rounded-lg font-bold hover:bg-green-700 transition"
            >
              חיבור וחיסור שברים
            </button>
            
            <button 
              onClick={() => startGame('calcGame')}
              className="p-4 bg-yellow-600 text-white rounded-lg font-bold hover:bg-yellow-700 transition"
            >
              כפל וחילוק מספרים דו-ספרתיים
            </button>
            
            <button 
              onClick={() => startGame('wordProblems')}
              className="p-4 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition"
            >
              שאלות מילוליות עם שברים
            </button>
          </div>
        </div>
      ) : gameCompleted ? (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4 text-blue-800">כל הכבוד {playerName}! סיימת את המשחק!</h2>
          <div className="text-3xl font-bold mb-6">ניקוד סופי: {score} מתוך {shuffledQuestions.length * 10}</div>
          
          <div className="p-4 bg-white rounded-lg shadow mb-8">
            <h3 className="text-lg font-bold text-blue-700 mb-2">סיכום</h3>
            <p>מספר שאלות: {shuffledQuestions.length}</p>
            <p>תשובות נכונות: {score / 10}</p>
            <p>אחוז הצלחה: {Math.round((score / (shuffledQuestions.length * 10)) * 100)}%</p>
          </div>
          
          {incorrectAnswers.length > 0 && (
            <div className="mb-8">
              <div 
                className="bg-white rounded-lg shadow p-4 mb-2 cursor-pointer"
                onClick={toggleSummary}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-bold text-red-700">שאלות שענית עליהן לא נכון ({incorrectAnswers.length})</h3>
                  <span>{summaryVisible ? '▼' : '◀'}</span>
                </div>
              </div>
              
              {summaryVisible && (
                <div className="bg-white rounded-lg shadow p-4">
                  {incorrectAnswers.map((item, index) => (
                    <div key={index} className="border-b border-gray-200 pb-4 mb-4 last:border-b-0 last:mb-0 last:pb-0">
                      <p className="mb-1"><strong>שאלה:</strong> {processText(item.question)}</p>
                      <p className="mb-1 text-red-600"><strong>התשובה שלך:</strong> {processText(item.yourAnswer)}</p>
                      <p className="mb-1 text-green-600"><strong>התשובה הנכונה:</strong> {processText(item.correctAnswer)}</p>
                      <p><strong>הסבר:</strong> {processText(item.explanation)}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          
          <div className="flex justify-center space-x-4 space-x-reverse">
            <button
              onClick={restartGame}
              className="px-6 py-2 bg-green-600 text-white rounded-md font-bold hover:bg-green-700 transition"
            >
              שחק שוב
            </button>
            
            <button
              onClick={backToMenu}
              className="px-6 py-2 bg-blue-600 text-white rounded-md font-bold hover:bg-blue-700 transition"
            >
              חזור לתפריט
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold text-blue-800">ניקוד: {score}</h2>
            <div className="text-lg font-semibold">שאלה {currentQuestion + 1} מתוך {shuffledQuestions.length}</div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow mb-6">
            <h3 className="text-xl mb-6">{processText(shuffledQuestions[currentQuestion]?.question)}</h3>
            
            {renderImage()}
            
            <div className="space-y-3 mt-4">
              {shuffledOptions.map((option, index) => (
                <button
                  key={index}
                  onClick={() => !showExplanation && handleAnswer(option)}
                  disabled={showExplanation}
                  className={`w-full p-3 text-right rounded-md font-medium transition-colors ${
                    selectedAnswer === option
                      ? isCorrect
                        ? 'bg-green-100 border-2 border-green-500'
                        : 'bg-red-100 border-2 border-red-500'
                      : 'bg-gray-100 hover:bg-gray-200'
                  }`}
                >
                  {processText(option)}
                </button>
              ))}
            </div>
          </div>
          
          {showExplanation && (
            <div className={`p-4 rounded-md mb-6 ${isCorrect ? 'bg-green-100' : 'bg-red-100'}`}>
              <h3 className="font-bold mb-2">
                {isCorrect 
                  ? `✓ נכון מאוד ${playerName}!` 
                  : `✗ לא מדויק ${playerName}.`}
              </h3>
              <p className="mb-2">
                <span className="font-bold">התשובה הנכונה: </span>
                {processText(shuffledQuestions[currentQuestion]?.correctAnswer)}
              </p>
              <p className="text-md">{processText(shuffledQuestions[currentQuestion]?.explanation)}</p>
            </div>
          )}
          
          {showExplanation && (
            <div className="text-center">
              <button
                onClick={nextQuestion}
                className="px-6 py-2 bg-blue-500 text-white rounded-md font-bold hover:bg-blue-600"
              >
                {currentQuestion < shuffledQuestions.length - 1 ? 'לשאלה הבאה' : 'סיים משחק'}
              </button>
            </div>
          )}
          
          {showReward && (
            <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-50">
              <div className="bg-yellow-300 text-yellow-800 p-8 rounded-lg shadow-lg animate-bounce">
                <h3 className="text-2xl font-bold">כל הכבוד {playerName}! 🎉</h3>
                <p className="text-xl">{rewardMessage}</p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EnhancedFractionsGame;